import Http from '@/http';
import { IGetMenuListReply, IGetPermissionsResponse } from './typings/menu';

export function apiGetMenuList() {
  return Http.get<void, IGetMenuListReply>('/hr/system/menu/list');
}
export function apiGetPermissions() {
  return Http.get<void, IGetPermissionsResponse>('/hr/system/menu/permission');
}
